import React from 'react';
import { Box, Grid, GridItem, VStack, Text, Container, Flex } from '@chakra-ui/react';
import { withPrefix } from 'gatsby';
import { Logo } from '../Logo';
import { Link } from '../Link';
import { DownloadLinks } from '../DownloadLinks';
import { ArrowLink } from '../ArrowLink';

export default function Footer() {
  return (
    <Box
      as='footer'
      bg='navy'
      color='white'
      backgroundImage={`url(${withPrefix('/pattern.svg')})`}
      backgroundRepeat='repeat'
      backgroundPosition='center'
      backgroundSize='80px'
      py={{ base: 30, xl: 60 }}
      px={{ base: 15, xl: 30 }}
    >
      <Container maxWidth='container.xl' padding='0'>
        <Grid
          gridTemplateColumns={['1fr', '1fr', '1fr', '1fr 1fr 1fr']}
          justifyContent='flex-start'
          gap={30}
        >
          <GridItem display='flex' alignItems='flex-start'>
            <Link
              to='/'
              _hover={{
                textDecoration: 'none',
                opacity: 0.8,
              }}
            >
              <Logo />
            </Link>
          </GridItem>

          <GridItem>
            <Flex direction='column' gap={5} alignItems='flex-start'>
              <Text textStyle='navItem'>About the IMF</Text>
              <Text>
                The International Monetary Fund (IMF) is a global organization of 190 member
                countries set up to promote the health of the world economy.
              </Text>
              <ArrowLink title='Learn More' href='https://www.imf.org/' color='white' />
            </Flex>
          </GridItem>

          <GridItem>
            <VStack spacing={5} alignItems='flex-start'>
              <Text textStyle='navItem'>Download The Report</Text>
              <DownloadLinks
                display='grid'
                gridTemplateColumns='1fr 1fr'
                gap={5}
                width='100%'
                variant='footer'
              />
            </VStack>
          </GridItem>
        </Grid>
      </Container>
    </Box>
  );
}
